/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//Swatch__Cube__Item__Collection__Page

// .addEventListener('click', function() {
//   var variant = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-variant-id');
// console.log('test')
//   console.log(variant)
//   var quantity = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-quantity');
//   var variantId = parseInt(variant, 10);
//   var quantity = parseInt(quantity, 10);
//   var product = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-product-id');
//   var productId = parseInt(product, 10);
//   var cart = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-id');
//   var cartId = parseInt(cart, 10);
//   var cartItem = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-id');
//   var cartItemId = parseInt(cartItem, 10);
//   var cartItemQuantity = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-quantity');
//   var cartItemQuantityId = parseInt(cartItemQuantity, 10);
//   var cartItemVariant = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-variant');
//   var cartItemVariantId = parseInt(cartItemVariant, 10);
//   var cartItemTitle = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-title');
//   var cartItemTitleId = parseInt(cartItemTitle, 10);
//   var cartItemPrice = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-price');
//   var cartItemPriceId = parseInt(cartItemPrice, 10);
//   var cartItemLinePrice = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-line-price');
//   var cartItemLinePriceId = parseInt(cartItemLinePrice, 10);
//   var cartItemLinePriceTotal = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-line-price-total');
//   var cartItemLinePriceTotalId = parseInt(cartItemLinePriceTotal, 10);
//   var cartItemLinePriceTotalTax = document.querySelector('.Swatch__Cube__Item__Collection__Page').getAttribute('data-cart-item-line-price-total-tax');
//   var cartItemLinePriceTotalTaxId = parseInt(cartItemLinePriceTotalTax, 10);

// })

const x = document.querySelectorAll('.Swatch__Cube__Item__Collection__Page');

function swatchEvent(element,event) {

  const dataUrl = element.getAttribute('data-image-url-tab')
  const dataId = element.getAttribute('data-image-id-tab')
  const dataAlt = element.getAttribute('data-image-alt-tab')
  const dataImage = element.getAttribute('data-image-variant-id-tab');
  //console.log('YYOOO',element)
  /*  FIXME: ADD THIS: */

  function imageOverlay() {
 
    if (element.parentElement.parentElement.previousSibling.nodeName === 'A') {
      const g = element.parentElement.parentElement.previousSibling;
      const h = g.querySelector('.Tab__Overlay__Image');

       if (g) {
        
          h.style.display = 'block';
          //h.setAttribute("data-src", 'https://cdn.shopify.com/s/files/1/0078/6631/8938/products/283A0985_600x.jpg?v=1675828583');
          //h.setAttribute("data-srcset", 'https://cdn.shopify.com/s/files/1/0078/6631/8938/products/283A0985_600x.jpg?v=1675828583');

          h.setAttribute("data-media-id", dataImage);
          h.alt = dataAlt;
          const r = dataUrl.replace(/{width}/g, "600"); // add more dynamic sizes here 
          h.src = r
      }
   }
  }

  function imageOverlayRemove() {
 
    if (element.parentElement.parentElement.previousSibling.nodeName === 'A') {
      const g = element.parentElement.parentElement.previousSibling;
      const h = g.querySelector('.Tab__Overlay__Image');

       if (g) {
        
          h.style.display = 'none';
          //h.setAttribute("data-src", 'https://cdn.shopify.com/s/files/1/0078/6631/8938/products/283A0985_600x.jpg?v=1675828583');
          //h.setAttribute("data-srcset", 'https://cdn.shopify.com/s/files/1/0078/6631/8938/products/283A0985_600x.jpg?v=1675828583');

          h.setAttribute("data-media-id", "");
          h.alt = "";
          
          h.src = ""
      }
   }
  }
  if(window.matchMedia("(pointer: coarse)").matches && event.type ===  "click"){
       imageOverlay()
       setTimeout(function(){ imageOverlayRemove() }, 3000);
  } 
  if(!window.matchMedia("(pointer: coarse)").matches && event.type ===  "mouseenter"){
   // console.log('test')
    imageOverlay()
   } 

   if(!window.matchMedia("(pointer: coarse)").matches && event.type ===  "mouseleave"){
    console.log('leave')
    imageOverlayRemove()
   }
    console.log(event.type);
    
    // console.log(dataUrl,dataId,dataAlt,dataImage)
    // console.log(dataUrl)
    // alt 
    // id 
   // console.log(element.parentElement.parentElement.previousSibling.nodeName)
   
    //.previousSibling
  
  
} 


x.forEach(element => element.addEventListener('mouseenter', (event) => swatchEvent(element,event)));
x.forEach(element => element.addEventListener('mouseleave', (event) => swatchEvent(element,event)));
x.forEach(element => element.addEventListener('click', (event) => swatchEvent(element,event)));

// x.forEach(element => element.addEventListener('click', event => {
  
//   }));


  // addEventListener('mouseenter', )
  // addEventListener('mouseleave', )

 // var myJavaScriptNumber = 3;


const c = document.querySelectorAll('.AspectRatio__container');
//const n = Math.floor(Math.random() * 100) + 1;
//console.log(c)

// c.forEach(element => {
//   element.innerHTML = `{%- if has_alternate_image -%}
//           {%- capture supported_sizes -%}{%- render 'image-size', sizes: '200,300,400,600,800,900,1000,1200', image: product.media[1] -%}{%- endcapture -%}

//           {%- assign image_url = product.media[1] | img_url: '1x1' | replace: '_1x1.', '_{width}x.' -%}

//           <img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="{{ image_url }}" data-widths="[{{ supported_sizes }}]" data-sizes="auto" alt="{{ product.media[1].alt | escape }}" data-media-id="{{ product.media[1].id }}">
//         {%- endif -%}

//         {%- capture supported_sizes -%}{%- render 'image-size', sizes: '200,400,600,700,800,900,1000,1200', image: product.featured_media -%}{%- endcapture -%}
//         {%- assign image_url = product.featured_media | img_url: '1x1' | replace: '_1x1.', '_{width}x.' -%}

//         <img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="{{ image_url }}" data-widths="[{{ supported_sizes }}]" data-sizes="auto" alt="{{ product.featured_media.alt | escape }}" data-media-id="{{ product.featured_media.id }}">
//         <span class="Image__Loader"></span>

//         <noscript>
//           <img class="ProductItem__Image ProductItem__Image--alternate" src="{{ product.media[1] | img_url: '600x' }}" alt="{{ product.media[1].alt | escape }}">
//           <img class="ProductItem__Image" src="{{ product.featured_media| img_url: '600x' }}" alt="{{ product.featured_media.alt | escape }}">
//         </noscript>`
// });
